import { getStorage, setStorage } from '@utils/localStorage';

const CACHE_KEY = 'clickedAll';

/** 缓存带“新”“热”tag的菜单 */
const cacheMenu = (name: string) => {
    const clickedAll = getStorage(CACHE_KEY) || '';
    if (clickedAll.indexOf(name) === -1) {
        setStorage(CACHE_KEY, clickedAll + name);
    }
};

export default cacheMenu;
